import { getMsgFromApiErr } from "@api/api";
import useRequestState from "@hooks/useRequestState";
import { useCallback, useEffect } from "react";
import getBanners, { BannerDetails } from "../getBanners";

const useGetBanners = (autoSend?: boolean) => {
  const { reqState, setLoading, setSuccess, setError } = useRequestState<BannerDetails[]>([]);

  const send = useCallback(async () => {
    setLoading();
    try {
      const banners = await getBanners();
      return setSuccess(banners);
    } catch (err: any) {
      return setError(getMsgFromApiErr(err));
    }
  }, [setError, setLoading, setSuccess]);

  useEffect(() => {
    if (autoSend) send();
    // prevents infinite loop
    // eslint-disable-next-line
  }, [autoSend]);

  return { ...reqState, data: reqState.data, send };
};

export default useGetBanners;
